import OrderedList from './ordered-list';

export default OrderedList;
